/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsHeroBanner = {
  init: function ($section) {
    
    // Add settings from schema to current object
    window.PXUTheme.jsHeroBanner = $.extend(this, window.PXUTheme.getSectionData($section));

    this.element = $section[0];

    this.correctContentContainerPosition();

    window.addEventListener("resize", this.correctContentContainerPosition.bind(this));
    if (this.mobileLayout) {
      this.enableMobileLayout();
      window.addEventListener("resize", this.enableMobileLayout.bind(this));
    }
    
    window.addEventListener("load", (event) => {
      this.correctContentContainerPosition.bind(this);
    });

    // this.splitMobileTitle();
    if (this.enableVideoScripts) {
      this._loadVideoScripts();
    }
  },
  correctContentContainerPosition: function() {
    // Container
    let container = this.element.querySelector(".Section__index-hero-banner--content_wrapper");
    let containerPos = container.getBoundingClientRect();
    if (!window.PXUTheme.media_queries.large.matches) {
      container.style.left = "";
      return;
    };
    // Get initial properties
    let containerStyles = getComputedStyle(container);
    let initialLeftProp = containerStyles.getPropertyValue('--left-offset');
    let initialTopProp = containerStyles.getPropertyValue('--top-offset');

    // Parent Container
    let parent = container.parentNode;  

    // Calculate properties in px
    let left = parent.offsetWidth * initialLeftProp / 100;
    let top = parent.offsetHeight * initialTopProp / 100;
  
    if (this.transformXEnabled) {
      if (left <= containerPos.width / 2) {
        container.style.left = containerPos.width / 2 + 30 + "px";
      } else {
        container.style.left = "";
      }
    };

    if (this.transformYEnabled) {
      if (top <= containerPos.height / 2) {
        // container.style.top = containerPos.height / 2 + 30 + "px";
      } else {
        // container.style.top = "";
      }
    }
  },
  showThemeEditorState: function(id, $section) {
    $($section).addClass("Editing");
    let images1 = $($section).find(".Unblur").removeClass("Unblur");
    let images2 = $($section).find(".BackgroundDrop").removeClass("BackgroundDrop");
    this.correctContentContainerPosition();
  },
  enableMobileLayout: function() {
    if (window.PXUTheme.media_queries.medium.matches) {
      let target = this.element.querySelector(".Section__index-hero-banner--content-oneliner");
      if (target) return;

      let wrapper = document.createElement("div");
      wrapper.classList.add("Section__index-hero-banner--content-oneliner");
      let parent = this.element.querySelector(".Section__index-hero-banner--content_wrapper-inner");
      parent.appendChild(wrapper);
      let elements = this.element.querySelectorAll("[data-mobile-layout='true']");
      elements[0].before(wrapper);
  
      let alignment = elements[0].getAttribute("data-vertical-alignment");
      wrapper.setAttribute("data-vertical-alignment", alignment);
      for (let element of elements) {
        wrapper.appendChild(element);
      };
      wrapper.classList.add("Active")
    } else {
      let target = this.element.querySelector(".Section__index-hero-banner--content-oneliner");
      if (!target) return;
      target.replaceWith(...target.childNodes);
    }
    
  },
  splitMobileTitle() {
    let titles = this.element.querySelectorAll(".Section__index-hero-banner--content-title");
    let targetTitle = titles[titles.length-1];
    let titleContent = targetTitle.textContent.split(" ");
    targetTitle.textContent = "";
    for (let item of titleContent) {
      let wrapper = document.createElement("div");
      wrapper.textContent = item;
      targetTitle.appendChild(wrapper);
    }
  },
  _loadVideoScripts() {
    var stylesheet = document.createElement('link');
    stylesheet.rel = 'stylesheet';
    stylesheet.href = 'https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css';
    document.head.appendChild(stylesheet);

    window.Shopify.loadFeatures([{
      name: 'video-ui',
      version: '1.0',
      onLoad: this._setupHtml5Video.bind(this)
    }]);
  },
  _setupHtml5Video() {
    this.players = Array.from(this.element.querySelectorAll("video")).map(video => {
      let poster = video.parentNode.dataset.poster;
      if (video.parentNode.classList.contains("Desktop")) {
        video.parentNode.classList.add("BackgroundDrop1", "fadeIn")
      } else if (video.parentNode.classList.contains("Mobile")) {
        video.parentNode.classList.add("BackgroundDropMobile1", "fadeIn")
      }
      let player = new Shopify.Plyr(video, {
        controls: false,
        clickToPlay: false,
        fullscreen: {
          enabled: false
        },
         autoplay: true
      });
      
      // setTimeout(()=>{
      //   player.play()
      // }, 3000);
      return player;
    });
  },
  unload: function ($section) { }
}

/******/ })()
;